var lib_core = require("lib-core");

if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var PackageMasterView = require('./packageMasterView.js');

var PackageMasterController = function(archLayers, dependencies, configuration) {
    ui_extensions.MasterController.call(this, archLayers, dependencies, configuration);
};

lib_core.inherit(PackageMasterController, ui_extensions.MasterController);

PackageMasterController.prototype.createView = function () {
    if (this.root.data.metaData && this.root.data.metaData())
        this.configuration.title = this.root.data.metaData().name;

    return new PackageMasterView(this.getModel(), this.getStatemachine(), this.editorHolder, this.configuration);
};

module.exports = PackageMasterController;
